import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import UnitButton from './UnitButton';

/**
 * UnitButtonBox has left/right mouse button controls, as well as
 * clickable, hoverable, buttons that are highlighted when active.
 * @reactProps {string[]} buttonValues - strings to be mapped to UnitButtons
 * @reactProps {string} title - the unit title for this set of values
 * @reactProps {string} classname - a string to assign the class name for the button box
 * @reactProps {function} onEvent - a handleUnitChange function from Main to deal with unit change.
 * @reactProps {function} change - flips the selected image index forward or back in DataCanvasContainer
 *                                (parent) so the selected image updates in the DataCanvas
 */
export default class UnitButtonBox extends React.Component {
  /**
   * store the current unit selection as the value itself of that unit
   * for conditional style (highlight)
   */
  state = {
    selected: this.props.buttonValues[0]
  };

  /**
   * Add event key listener
   */
  componentDidMount() {
    document.addEventListener('keydown', this.onArrowDown);
  }

  /**
   * Remove event key listener
   */
  componentWillUnmount() {
    document.removeEventListener('keydown', this.onArrowDown);
  }

  /**
   * generator returns the index of selected
   */
  get selectedIndex() {
    const {
      props: { buttonValues: values },
      state: { selected }
    } = this;

    return (values || []).indexOf(selected);
  }

  /**
   * Highlight stores the current selection,
   * passes that index up to DataCanvasContainer
   * and sends the selected unit to Main for handling the img src
   */
  highlight = value => {
    this.setState({ selected: value });
    this.props.onEvent(value);
    this.props.change(this.selectedIndex);
  };

  /**
   * onArrowDown handles the logic of the arrow key listeners.
   * selected index increases or decreases with respect to button values
   * and values are highlighted as arrow keys are pressed.
   * @param {event deconstructed to key type} key - the ArrowLeft or ArrowRight
   */
  onArrowDown = ({ key }) => {
    const { buttonValues: values = [] } = this.props;
    //const i = ~this.selectedIndex ? 0 : this.selectedIndex;
    const keyMap = {
      ArrowLeft: () =>
        values[
          this.selectedIndex > 0 ? this.selectedIndex - 1 : values.length - 1
        ],
      ArrowRight: () =>
        values[
          this.selectedIndex < values.length - 1 ? this.selectedIndex + 1 : 0
        ]
    };
    const fn = keyMap[key];

    //console.log(typeof fn === 'function');

    this.highlight(fn());
    //this.props.change(this.selectedIndex);
    if (!fn || !fn()) {
      return;
    }
  };

  /**
   * Renders a button-box of a buttons box filled with unit buttons.
   * @return div > div > h3, div > UnitButtons
   */
  render() {
    const { classname, title, buttonValues: buttons } = this.props;
    return (
      <div className={cx('button-box', classname)}>
        <div className="title">
          <h3>{title}</h3>
        </div>
        <div className="buttons">
          {buttons.map((val, i) => (
            <UnitButton
              selected={val === this.state.selected}
              value={val}
              label={Number(val)}
              highlight={this.highlight}
              key={i}
            />
          ))}
        </div>
      </div>
    );
  }
}

UnitButtonBox.propTypes = {
  title: PropTypes.string,
  classname: PropTypes.string,
  buttonValues: PropTypes.array,
  onEvent: PropTypes.func,
  change: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/UnitButtonBox.js